import { Button, Flex, Tag } from 'antd';
import Image from 'next/image';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { userSelector } from '@store/user/user.slice';
import { EUnitDisplay, IProduct } from '@type/product';
import { formatVND } from '@utils/index';
import { If } from '@components/condition';

interface Props {
  product: IProduct;
  onAddToCart: (product: IProduct) => void;
  onClick?: () => void;
}

function ProductCardBase(props: Props) {
  const { product, onAddToCart } = props;
  const { isAuth, user } = useSelector(userSelector);

  return (
    <div className="p-2 bg-white border border-slate-100 rounded hover:shadow-md w-full relative transition-all duration-300">
      <Flex align="center" gap="small">
        <div className="relative w-12 h-12 overflow-hidden rounded flex-shrink-0 ">
          <Image
            src={product.images[0] || '/img/image_empty.svg'}
            alt={product.name}
            sizes="(max-width: 768px) 100px, 120px"
            fill
            className="!w-full !h-full object-cover rounded"
          />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <strong className="text-sm font-medium">{product.name} </strong>
          <Flex justify="space-between" align="center">
            <div>
              <Tag color="purple" className="!text-[10px] rounded-[2px] leading-none py-[2px] px-1">
                {product?.category?.name}
              </Tag>
              <If
                condition={isAuth}
                Then={
                  <b className="text-sm text-gray-700">
                    {formatVND(
                      user?.isTax
                        ? product?.finalPrice + product?.finalPrice * (product?.tax / 100)
                        : product?.finalPrice
                    )}{' '}
                    <span className="text-xs">đ/{EUnitDisplay[product?.unitName] || 'cái'}</span>
                  </b>
                }
                Else={
                  <p className="text-[10px] text-gray-700 my-1">Vui lòng đăng nhập để xem giá</p>
                }
              />
            </div>
            <Button
              type="primary"
              size="small"
              onClick={() => onAddToCart(product)}
              className="font-semibold text-[11px]"
            >
              Thêm
            </Button>
          </Flex>
        </div>
      </Flex>
    </div>
  );
}

export const ProductCard = memo(ProductCardBase);
